import styled from 'styled-components';

export const StyledMachinePositionHistoryMapPin = styled.div`
  font-family: ${({ theme }): string => theme.kcc.typography.FONT_FAMILY};
  font-size: ${({ theme }): number => theme.kcc.typography.FONT_SIZE.LG}px;
  font-weight: ${({ theme }): number => theme.kcc.typography.FONT_WEIGHT.BOLD};
  line-height: ${({ theme }): number => theme.kcc.typography.LINE_HEIGHT.BASE};

  width: 40px;
  height: 48px;
  z-index: 500;
  cursor: pointer;

  .machine-position-history-map-pin__content {
    display: flex;
    align-items: center;
  }

  .machine-position-history-map-pin__marker-container {
    display: flex;
    position: relative;
    width: 100%;
    height: 47px;
    transform-origin: 50% 100%;
    transition: 100ms linear;

    &:hover {
      transform: scale(1.15);
    }
  }

  .machine-position-history-map-pin__order-label {
    position: absolute;
    font-size: 16px;
    font-weight: 700;
    width: 100%;
    text-align: center;
    z-index: 600;
    top: 8px;
    color: ${({ theme }): string => theme.kcc.colors.BLACK};
    margin: 0;

    &--clicked {
      color: ${({ theme }): string => theme.kcc.colors.WHITE};
    }
  }

  .machine-position-history-map-pin__map-marker {
    position: absolute;
    align-items: flex-start;
    color: ${({ theme }): string => theme.kcc.colors.WHITE};
    filter: drop-shadow(0px 0px 8px rgba(0, 0, 0, 0.3));

    path {
      fill: ${({ theme }): string => theme.kcc.colors.WHITE};
    }

    &--clicked {
      color: ${({ theme }): string => theme.kcc.colors.BLACK};

      path {
        fill: ${({ theme }): string => theme.kcc.colors.BLACK};
      }
    }
  }

  .machine-position-history-map-pin__overlay {
    width: 100%;
    height: 100%;
    overflow: hidden;
    z-index: 600;
  }
`;
